<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiArrowRightThick } from "@mdi/js";
export default {
  name: "MdiArrowRightThick",
  data() {
    return {
      svgPath: mdiArrowRightThick,
    };
  },
};
</script>
